import { MessageBar, useClassNames } from '@h2oai/ui-kit';

import { useBanner } from '../../utils/hooks';
import { bannerBarStylesDefault, IBannerBarStyles } from './BannerBarStyles';

interface IBannerBarClassNames {
  root: string;
  messageBar: string;
}

export function BannerBar() {
  const { banners, remove } = useBanner();
  const classNames = useClassNames<IBannerBarStyles, IBannerBarClassNames>('BannerBar', bannerBarStylesDefault);
  return banners.length ? (
    <div className={classNames.root}>
      {banners.map((m) => {
        const { id, message, onDismiss, ...messageBarProps } = m;
        return (
          <div key={id} className={classNames.messageBar}>
            <MessageBar
              {...messageBarProps}
              onDismiss={
                onDismiss
                  ? () => {
                      remove(m.id);
                      onDismiss();
                    }
                  : undefined
              }
            >
              {message}
            </MessageBar>
          </div>
        );
      })}
    </div>
  ) : null;
}
